import React from 'react'
import FindCta from '~/components/molecules/FindCta';
import { StaticImage } from 'gatsby-plugin-image';
import { ctaLabels } from '~/data/translations/ctaLabels';
export default function FooterFindCta({pageLanguage}) {
  const labels = ctaLabels[pageLanguage] || ctaLabels.en;

  return (
    <div className="lg:flex items-center">
      <div className="mb-20">
        <FindCta subheading={labels.subheading} heading={labels.heading} buttonText={labels.buttonLabel} subheadingClassName="text-blue" />
      </div>
      <div className="-ml-6 -mr-6 lg:ml-auto mb-10 lg:mb-12 lg:-mr-40">
        <StaticImage src={'../../assets/images/footer-illustration.png'} className="w-full lg:w-[36rem]" alt="CityRelay" />
      </div>
    </div>
  )
}
